import { MasonryGallery } from '../../Constant';
import GalleryContext from '../../Helper/Gallery';
import { H4, Image, Breadcrumbs } from '../../AbstractElements';
import React, { Fragment, useContext, useState, useEffect } from 'react';
import Masonry from 'react-masonry-css';
import { Container, Row, Col, Card, CardBody, CardHeader } from 'reactstrap';
import { PhotoSwipeGallery } from 'react-photoswipe';
import 'react-photoswipe/lib/photoswipe.css';
import AddImage from './AddImage';
import axios from 'axios';
import { ServerPath } from '../../Constant/index.jsx';
import { Trash2 } from 'react-feather';
import Swal from 'sweetalert2';
import './MesonryGallery.css'
import { _axios } from '../../utils/axios.jsx';

const MesonryGalleryContain = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await _axios.get(`${ServerPath}/gallery`);
        const actualData = response?.data?.data;
        setData(actualData);
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, []);

  const styles = { width: '100%', height: '300px', objectFit: 'cover' };

  const breakpointColumnsObj = {
    default: 4,
    1199: 3,
    700: 2,
    500: 1
  };

  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openGallery = (index) => {
    setIsOpen(true);
    setCurrentIndex(index);
  };

  const closeGallery = () => {
    setIsOpen(false);
  };

  const deleteImage = async (imgid, event) => {
    event.stopPropagation();
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, cancel!',
      customClass: {
        container: 'swal2-container'
      }
    });

    if (result.isConfirmed) {
      try {
        await _axios.delete(`${ServerPath}/gallery/${imgid}`);
        setData(prevUsers => prevUsers.filter(item => item.img_id !== imgid));
        Swal.fire(
          'Deleted!',
          'Your user has been deleted.',
          'success'
        );
      } catch (error) {
        console.error('Error deleting user:', error);
        Swal.fire(
          'Error!',
          'There was an error deleting the user.',
          'error'
        );
      }
    }
  };

  return (
    <Fragment>
      <div className='row'>
        <div className='col-12 col-md-6 col-lg-6'>
          <Breadcrumbs mainTitle="Gallery" parent="Gallery" title="Gallery" />
        </div>
        <div className='col-12 col-md-6 col-lg-6'>
          <AddImage />
        </div>
      </div>
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody className="photoswipe-pb-responsive">
                <Masonry
                  breakpointCols={breakpointColumnsObj}
                  className="my-gallery row grid gallery"
                  columnClassName="col-md-3 col-6 grid-item">
                  {data.map((element, index) =>
                    <figure key={element.img_id} style={{ position: 'relative', overflow: 'hidden' }} onClick={() => openGallery(index)}>
                      <div
                        className="delete-icon-wrapper"
                        onClick={(e) => deleteImage(element.img_id, e)}
                      >
                        <Trash2 className="delete-icon" />
                      </div>
                      <Image attrImage={{ src: element.image, style: styles, alt: '' }} key={element.img_id} />
                    </figure>
                  )}
                </Masonry>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      {isOpen && (
        <PhotoSwipeGallery
          isOpen={isOpen}
          items={data.map(element => ({
            src: element.image,
            w: 1200,
            h: 900
          }))}
          options={{ index: currentIndex, bgOpacity: 0.7, closeOnScroll: false }}
          onClose={closeGallery}
        />
      )}
    </Fragment>
  );
};

export default MesonryGalleryContain;
